import { useSyncExternalStore } from 'react'

function subscribe(onChange: () => void): () => void {
  window.addEventListener('resize', onChange)
  return () => window.removeEventListener('resize', onChange)
}

const getWidth = () => window.innerWidth
const getHeight = () => window.innerHeight

/** The window's inner size (px), re-rendering on every window resize. */
export function useViewportSize(): { width: number; height: number } {
  const width = useSyncExternalStore(subscribe, getWidth, getWidth)
  const height = useSyncExternalStore(subscribe, getHeight, getHeight)
  return { width, height }
}
